<template>
  <v-row justify="center" align="center">
    <v-col cols="12" md="8" sm="12">
      <v-card elevation="12">
        <v-toolbar color="primary" dark flat dense>
          <v-toolbar-title>User Registration</v-toolbar-title>
          <v-spacer />
          <v-btn text exact @click="$router.go(-1)">
            <v-icon left>arrow_back</v-icon>Back
          </v-btn>
        </v-toolbar>
        <div class="py-0">
          <v-img :src="logo" class="my-3" contain height="140" />
        </div>

        <v-stepper
          v-model="currentStep"
          class="elevation-0"
          style="background-color: var(--v-background-base)"
        >
          <v-stepper-header v-if="isCncOnly && isCncEnabled">
            <v-stepper-step :complete="currentStep > 1" step="1"
              >Postcode</v-stepper-step
            >
            <v-divider></v-divider>
            <v-stepper-step :complete="currentStep > 2" step="2"
              >Click & Collect</v-stepper-step
            >
            <v-divider></v-divider>
            <v-stepper-step :complete="currentStep > 3" step="3"
              >User Information</v-stepper-step
            >
            <v-divider></v-divider>
            <v-stepper-step step="4">Delivery Information</v-stepper-step>
          </v-stepper-header>
          <v-stepper-header v-else>
            <v-stepper-step :complete="currentStep > 1" step="1"
              >Postcode</v-stepper-step
            >
            <v-divider></v-divider>
            <v-stepper-step :complete="currentStep > 2" step="2"
              >User Information</v-stepper-step
            >
            <v-divider></v-divider>
            <v-stepper-step step="3">Delivery Information</v-stepper-step>
          </v-stepper-header>
          <v-stepper-items v-if="isCncOnly">
            <v-card-text style="text-align: end" class="py-0">
              <v-btn
                v-if="currentStep != 1"
                color="primary"
                text
                @click="currentStep--"
              >
                <v-icon left>mdi-keyboard-backspace</v-icon> Previous
              </v-btn>
            </v-card-text>

            <v-stepper-content step="1">
              <PostcodeRequest
                :isRequestPostcode="notRequest"
                :descriptionText="descText1"
                :isRegistrationPage = "isRegPage"
                @validated="nextStep"
              ></PostcodeRequest>
            </v-stepper-content>
            <v-stepper-content step="2">
              <ClickAndCollectOnly
                @valid-cnc-check="nextStep"
              ></ClickAndCollectOnly>
            </v-stepper-content>
            <v-stepper-content step="3">
              <UserInformation
                :userDetails="userInfo"
                :error="userInfoError"
                :errorMessage="userInfoErrorMessage"
                @valid-user-info="nextStep"
              ></UserInformation>
            </v-stepper-content>
            <v-stepper-content step="4">
              <DeliveryInformation
                :deliveryAddress="deliveryInfo"
                :error="error"
                :errorMessage="errorMessage"
                :onRegister="completeRegistration"
              ></DeliveryInformation>
            </v-stepper-content>
          </v-stepper-items>
          <v-stepper-items v-else>
            <v-card-text style="text-align: end" class="py-0">
              <v-btn
                v-if="currentStep != 1"
                color="primary"
                text
                @click="currentStep--"
              >
                <v-icon left>mdi-keyboard-backspace</v-icon> Previous
              </v-btn>
            </v-card-text>

            <v-stepper-content step="1">
              <PostcodeRequest
                :isRequestPostcode="notRequest"
                :descriptionText="descText1"
                :isRegistrationPage = "isRegPage"
                @validated="nextStep"
              ></PostcodeRequest>
            </v-stepper-content>
            <v-stepper-content step="2">
              <UserInformation
                :userDetails="userInfo"
                :error="userInfoError"
                :errorMessage="userInfoErrorMessage"
                @valid-user-info="nextStep"
              ></UserInformation>
            </v-stepper-content>
            <v-stepper-content step="3">
              <DeliveryInformation
                :deliveryAddress="deliveryInfo"
                :error="error"
                :errorMessage="errorMessage"
                :onRegister="completeRegistration"
              ></DeliveryInformation>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import PostcodeRequest from "@/components/auth/PostcodeRequestForm.vue";
import UserInformation from "@/components/auth/UserInfoForm.vue";
import DeliveryInformation from "@/components/auth/DeliveryInfoForm.vue";
import ClickAndCollectOnly from "@/components/auth/ClickAndCollectOnly.vue";
import { mapActions } from "vuex";
import PostcodeRequestForm from "../../components/auth/PostcodeRequestForm.vue";
export default {
  name: "Registration",
  components: {
    PostcodeRequest,
    UserInformation,
    DeliveryInformation,
    ClickAndCollectOnly,
},
  data: () => {
    return {
      userInfo: {
        userName: "",
        email: "",
        telephone: "",
        password: "",
        confirmPassword: "",
      },
      deliveryInfo: {
        addressLine1: "",
        addressLine2: "",
        addressLine3: "",
        addressLine4: "",
        postcode: "",
      },
      userInfoError: false,
      userInfoErrorMessage: "",
      error: false,
      errorMessage: "",
      currentStep: 1,
       descText1:
        "Please enter your postcode below to check if we deliver to your address.",
      notRequest: false,
      isRegPage : true
    };
  },
  methods: {
    ...mapActions(["registerNewCashUser", "setSnackbar"]),
    completeRegistration() {
      //make call to registerUserAction if response is success
      //redirect user to SignIn page
      //else flag the eroor
      this.error = false;
      this.errorMessage = "";
      this.userInfoError = false;
      this.userInfoErrorMessage = "";

      const rec = Object.assign(
        {},
        { identity: "nws9987" },
        { emailAddress: this.userInfo.email.trim() },
        { password: this.userInfo.password.trim() },
        { userName: this.userInfo.userName.trim() },
        { telephone: this.userInfo.telephone.trim() },
        { postcode: this.deliveryInfo.postcode.trim() },
        { addressLine1: this.deliveryInfo.addressLine1.trim() },
        { addressLine2: this.deliveryInfo.addressLine2.trim() },
        { addressLine3: this.deliveryInfo.addressLine3.trim() },
        { addressLine4: this.deliveryInfo.addressLine4.trim() }
      );
      this.registerNewCashUser(rec)
        .then((response) => {
          if (response == "registration-complete") {
            this.$root.$emit("singup-success", this.userInfo.email);
            this.resetForm();
            this.setSnackbar({ text: "Thank You !.  Registration Successful" });
            this.$router.push({ name: "SignIn" });
            this.currentStep = 1;
          }
        })
        .catch((msg) => {
          if (msg.includes("email address")) {
            this.previousStep();
            this.userInfoError = true;
            this.userInfoErrorMessage = msg;
          }
          this.error = true;
          this.errorMessage = msg;
          this.setSnackbar({ text: msg, color: "error" });
        });
    },
    nextStep(e) {
      this.currentStep = this.currentStep + 1;
      if (e) {
        this.deliveryInfo.postcode = e;
      }
    },
    previousStep() {
      this.currentStep = this.currentStep - 1;
    },
    resetForm() {
      this.userInfo.userName = "";
      this.userInfo.email = "";
      this.userInfo.telephone = "";
      this.userInfo.password = "";
      this.userInfo.confirmPassword = "";
      this.deliveryInfo.addressLine1 = "";
      this.deliveryInfo.addressLine2 = "";
      this.deliveryInfo.addressLine3 = "";
      this.deliveryInfo.addressLine4 = "";
      this.deliveryInfo.postcode = "";
    },
  },
  computed: {
    logo() {
      return require(process.env.VUE_APP_LOGO_MAIN);
    },
    isCncOnly() {
      return this.$store.state.user.cncOnly == "1";
    },
    isCncEnabled() {
      return this.$store.state.configs.orders_cnc_enabled == "1";
    },
  },
  created() {
    this.resetForm();
  },
};
</script>
<style scoped>
.v-stepper__content {
  padding-top: 16px;
  padding-right: 12px;
  padding-bottom: 16px;
  padding-left: 12px;
}
</style>
